import type { AbilityRecord } from "../../shared/api/generated/contracts";
interface OverlayChange {
  kind: "create" | "update" | "delete";
  record: AbilityRecord;
}
export class PreviewRecordOverlay {
  private readonly changes = new Map<string, OverlayChange>();
  create(record: AbilityRecord): void {
    this.changes.set(record.id, { kind: "create", record });
  }
  update(record: AbilityRecord): void {
    this.changes.set(record.id, { kind: "update", record });
  }
  delete(record: AbilityRecord): void {
    this.changes.set(record.id, { kind: "delete", record });
  }
  apply(records: readonly AbilityRecord[]): AbilityRecord[] {
    const result = new Map(records.map((record) => [record.id, record]));
    for (const [id, change] of this.changes)
      if (change.kind === "delete") {
        result.delete(id);
      } else {
        result.set(id, change.record);
      }
    return [...result.values()];
  }
  get size(): number {
    return this.changes.size;
  }
  clear(): void {
    this.changes.clear();
  }
}
